import i18next from 'i18next'
import i18nResources from '@/config/i18n-locales'

export function init () {
  i18next.init({
    lng: 'pt-BR',
    resources: i18nResources
  })
  return i18next
}

export function t (key) {
  return i18next.t(key)
}
